import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  FormHelperText,
  Dialog,
  styled,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

import { DatePicker } from "components/pickers";

import { fr, enGB } from "date-fns/locale"; // import French and English locale

// Highcharts component
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import SwipeableViews from "react-swipeable-views";
import { useTranslation } from "react-i18next";
import AllergiesTab from "./entryTabs/Allergies";
import AnthropometricsTab from "./entryTabs/Anthropometrics";
import LabResultsTab from "./entryTabs/LabResults";
import { ReactTabulator } from "react-tabulator";
import { getARVFacilityList } from "../../../services/Common";

import NextPrevBtn from "../../../services/NextPrevBtn";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paperWidthSm": {
    maxWidth: theme.spacing(700),
  },
}));

/** Coerce API / MySQL boolean-ish values for MUI Checkbox `checked` (boolean). */
function checkboxChecked(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value == null || value === "")
    return false;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    return s === "1" || s === "true" || s === "yes";
  }
  return Boolean(value);
}

/** Avoid React warning: controlled <input> value must not be null. */
function fieldStr(v) {
  return v == null ? "" : v;
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const PatientFormData = ({
  tabValue,
  errorObject,
  handleRDateChange,
  handleChangeIndex,
  tabChangeHandler,
  addPatientForm,
  formData,
  handleChange,
  handleCheck,
  handleCheckPreEP,
  handleCheckisArmy,
  handleReset,
  handleSubmit,
  handleUpdate,
  handleChangeByTabs,
  handleSubmitByTabs,
  allergyData,
  openAllergyDialog,
  setOpen,
  handleClickOpen,
  handleClose,
  handleRDateChangeByTabs,
  allergyDataColumns,
  anthropometricDataColumns,
  openAnthropometricDialog,
  anthropometricData,
  labResultsDataColumns,
  openLabResultDialog,
  labResultData,
  errorAllergiesData,
  errorAnthropometricsData,
  errorLabResultsData,
  patientsPrescriptions,
  prescriptionDataColumns,
  calculateWeightCD4Count,
  calculateViralLoad,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setTabValue] = useState(0);
  const { t, i18n } = useTranslation();
  const lan = localStorage.getItem("LangCode");
  const menukey = "patients";

  const StockData = JSON.parse(localStorage.getItem("PatientDataNextPrev"));

  const StockDataIndex = JSON.parse(localStorage.getItem("PatientDataIndex"));

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );

  const Gender = JSON.parse(localStorage.getItem("Gender"));
  const OriginType = JSON.parse(localStorage.getItem("OriginType"));
  const CountryAll = JSON.parse(localStorage.getItem("CountryAll"));
  const MaritalStatus_List = JSON.parse(
    localStorage.getItem("MaritalStatus_List"),
  );

  const PatientCoInfection_List = JSON.parse(
    localStorage.getItem("PatientCoInfection_List"),
  );
  const KeyPopulationType_List = JSON.parse(
    localStorage.getItem("KeyPopulationType_List"),
  );
  const CohortTypeList = JSON.parse(localStorage.getItem("CohortTypeList"));

  /*  const FacilityList = JSON.parse(
    localStorage.getItem("FacilityList")
  );
 */

  const FacilityList = getARVFacilityList();

  //====== Start Choosen Dropdown===========
  const [chosenValues, setChosenValues] = useState({
    TransferFromFacilityId: null,
    TransferToFacilityId: null,
    CohortId: null,
    ProtocolId: null,
    TransferFromCountryId: null,
    TransferToCountryId: null,
  });

  useEffect(() => {
    let chosenValuesData = { ...chosenValues };

    chosenValuesData["TransferFromFacilityId"] =
      FacilityList.find(
        (Facility_List) => Facility_List.id == formData.TransferFromFacilityId,
      ) ?? null;
    chosenValuesData["TransferToFacilityId"] =
      FacilityList.find(
        (Facility_List2) => Facility_List2.id == formData.TransferToFacilityId,
      ) ?? null;
    chosenValuesData["CohortId"] =
      CohortTypeList.find(
        (CohortTypeList2) => CohortTypeList2.id == formData.CohortId,
      ) ?? null;
    chosenValuesData["ProtocolId"] =
      CurrentRegimen.find(
        (CurrentRegimen2) => CurrentRegimen2.id == formData.ProtocolId,
      ) ?? null;

    chosenValuesData["TransferFromCountryId"] =
      CountryAll.find((list) => list.id == formData.TransferFromCountryId) ??
      null;

    chosenValuesData["TransferToCountryId"] =
      CountryAll.find((list) => list.id == formData.TransferToCountryId) ??
      null;
    setChosenValues(chosenValuesData);
  }, [
    formData.TransferFromFacilityId,
    formData.TransferToFacilityId,
    formData.CohortId,
    formData.ProtocolId,
    formData.TransferFromCountryId,
    formData.TransferToCountryId,
  ]);

  const handleChangeChoosen = (name, valueobj, value) => {
    let chosenValuesData = { ...chosenValues };
    chosenValuesData[name] = valueobj;
    setChosenValues(chosenValuesData);
    props.handleChangeChoosenProps(name, value);
  };

  //====== End Choosen Dropdown===========

  const language_preference = JSON.parse(
    localStorage.getItem("language_preference"),
  );
  const CurrentRegimen = JSON.parse(localStorage.getItem("CurrentRegimen"));
  const MMDStatus = JSON.parse(localStorage.getItem("MMDStatus"));
  const LABTest_List = JSON.parse(localStorage.getItem("LABTest_List"));

  const editUser = (data) => {
    window.open(
      process.env.REACT_APP_BASE_NAME + `/prescription/edit/${data.id}`,
    );
  };

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editUser(rowData);
  };

  const patientInfoEnableDisableToggle = () => {
    let t = document.getElementById("patientInfoEnableDisable");
    t.classList.toggle("fa-eye-slash");

    let EnableDisable = document.getElementById("EnableDisablePInfo");
    EnableDisable.classList.toggle("EnableDisablePInfo");

    let btnPanelHide_1 = document.getElementById("btnPanelHide_1");
    btnPanelHide_1.classList.toggle("btnHide");

    let btnPanelHide_2 = document.getElementById("btnPanelHide_2");
    btnPanelHide_2.classList.toggle("btnShow");
  };

  const handleIndex = (indx, row) => {
    localStorage.setItem("PatientDataIndex", JSON.stringify(indx));
    let route = `${row.id}`;
    props.history.push(route);
  };

  /* =====Start of Print Excel Many Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintMany = () => {
    let finalUrl = EXCEL_EXPORT_URL + "report/patient_history_pdf.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        /* "&PrescriptionId=" +
         props.match.params.id + */
        "&PatientId=" +
        formData.id +
        "&TimeStamp=" +
        Date.now(),
    );
  };

  /* =====End of Excel Export Code==== */

  return (
    <div className={classes.patientPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3__">
          <Grid container>
            <Grid item xs={12} sm={12}>
              <div className="sw_page_heading">
                <div className="sw_heading_title">
                  {t(DispensingLanguage[lan][menukey]["Patient Entry"])} -{" "}
                  {addPatientForm
                    ? DispensingLanguage[lan][menukey]["ADD"]
                    : DispensingLanguage[lan][menukey]["EDIT"]}
                  <button
                    className="EnableDisableToggle"
                    type="button"
                    onClick={() => patientInfoEnableDisableToggle()}
                  >
                    <i id="patientInfoEnableDisable" className="fa fa-eye"></i>
                  </button>
                </div>

                <div className="float-end sw_btn_control">
                  <div id="btnPanelHide_1">
                    {addPatientForm ? (
                      <Grid item xs={12} className="text-center">
                        <Button
                          disabled={!!props.permissionType}
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => handleReset()}
                        >
                          {t(DispensingLanguage[lan][menukey]["Reset"])}
                        </Button>
                        <Button
                          disabled={!!props.permissionType}
                          className="me-2"
                          variant="contained"
                          color="primary"
                          onClick={() => handleSubmit()}
                        >
                          {t(DispensingLanguage[lan][menukey]["Save"])}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => props.history.push("/patients")}
                        >
                          {t(DispensingLanguage[lan][menukey]["Back to List"])}
                        </Button>
                      </Grid>
                    ) : (
                      <Grid item xs={12} className="text-center">
                        <Button
                          disabled={!!props.permissionType}
                          className="me-2"
                          variant="contained"
                          color="primary"
                          onClick={() => handleUpdate()}
                        >
                          {t(DispensingLanguage[lan][menukey]["update"])}
                        </Button>
                        <Button
                          className="me-2"
                          variant="contained"
                          color="gray"
                          type="reset"
                          onClick={() => props.history.push("/patients")}
                        >
                          {t(DispensingLanguage[lan][menukey]["Back to List"])}
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          className="me-2 sw_icons"
                          onClick={() => PrintMany()}
                        >
                          <i className="fas fa-print"></i>
                        </Button>
                      </Grid>
                    )}
                  </div>
                  <div id="btnPanelHide_2" className="btnHide">
                    <Grid item xs={12} className="text-center">
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/patients")}
                      >
                        {t(DispensingLanguage[lan][menukey]["Back to List"])}
                      </Button>
                    </Grid>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

        <div id="EnableDisablePInfo">
          {addPatientForm ? (
            <></>
          ) : (
            <NextPrevBtn
              dataList={StockData}
              StockDataIndex={StockDataIndex}
              handleReset={handleReset}
              handleIndex={handleIndex}
              {...props}
            />
          )}

          {/* EnableDisablePInfo */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                // required
                // error={!!errorObject.lastName}
                // helperText={errorObject.lastName}
                disabled={true}
                id="lastName"
                name="lastName"
                label={DispensingLanguage[lan][menukey]["Last Name"]}
                value={fieldStr(formData.lastName)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                // required
                // error={!!errorObject.firstName}
                // helperText={errorObject.firstName}
                disabled={true}
                id="firstName"
                name="firstName"
                label={DispensingLanguage[lan][menukey]["First Name"]}
                value={fieldStr(formData.firstName)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                disabled={true}
                id="knownName"
                name="knownName"
                label={DispensingLanguage[lan][menukey]["Known Name"]}
                value={fieldStr(formData.knownName)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={lan === "en_GB" ? enGB : fr}
              >
                <DatePicker
                  disabled={!!props.permissionType}
                  label={DispensingLanguage[lan][menukey]["DoB"]}
                  disableFuture={true}
                  value={formData.dob || null}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => handleRDateChange(e, "dob")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      required
                      error={!!errorObject.dob}
                      helperText={errorObject.dob}
                      id="dob-date-picker-dialog"
                      name="dob"
                      fullWidth
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormControl
                className="sw_radiogroup"
                component="fieldset"
                required
                error={!!errorObject.gender}
                disabled={!!props.permissionType}
              >
                <FormLabel component="legend">
                  {DispensingLanguage[lan][menukey]["Gender"]}
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender"
                  value={fieldStr(formData.gender)}
                  onChange={handleChange}
                >
                  {Gender.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={item.id}
                        value={item.id}
                        control={<Radio />}
                        label={item.name}
                      ></FormControlLabel>
                    );
                  })}
                </RadioGroup>
                {errorObject.gender ? (
                  <FormHelperText error>{errorObject.gender}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormControl variant="standard" className={classes.fullWidth}>
                <InputLabel id="demo-simple-select-label">
                  {DispensingLanguage[lan][menukey]["Marital Status"]}
                </InputLabel>
                <Select
                  disabled={!!props.permissionType}
                  labelId="marital-status-select-label"
                  id="maritalStatus"
                  name="maritalStatus"
                  value={fieldStr(formData.maritalStatus)}
                  onChange={handleChange}
                  label={DispensingLanguage[lan][menukey]["Marital Status"]}
                >
                  {MaritalStatus_List.map((item, index) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                required
                error={!!errorObject.idNumber}
                helperText={errorObject.idNumber}
                id="idNumber"
                name="idNumber"
                disabled={!!props.permissionType}
                label={DispensingLanguage[lan][menukey]["ID Number"]}
                value={fieldStr(formData.idNumber)}
                fullWidth
                autoComplete="given-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                disabled={true}
                id="pass"
                name="pass"
                label={DispensingLanguage[lan][menukey]["PAS#"]}
                value={fieldStr(formData.pass)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                id="ipn"
                name="ipn"
                disabled={!!props.permissionType}
                label={DispensingLanguage[lan][menukey]["IPN"]}
                value={fieldStr(formData.ipn)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormControl variant="standard" className={classes.fullWidth}>
                <InputLabel id="language-preference-select-label">
                  {DispensingLanguage[lan][menukey]["Language Preference"]}
                </InputLabel>
                <Select
                  disabled={!!props.permissionType}
                  labelId="marital-status-select-label"
                  id="languagePreference"
                  name="languagePreference"
                  value={fieldStr(formData.languagePreference)}
                  onChange={handleChange}
                  label={
                    DispensingLanguage[lan][menukey]["Language Preference"]
                  }
                >
                  {language_preference.map((item, index) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            {/* <Grid item xs={12} sm={2} className="sw_active_patient"> */}
            <Grid item xs={12} sm={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    disabled={
                      formData.deceased ||
                      formData.stopped ||
                      formData.transferredOut ||
                      formData.PreEP ||
                      formData.defaulter ||
                      props.permissionType
                        ? true
                        : false
                    }
                    checked={checkboxChecked(formData.active)}
                    onChange={(e) => handleCheck(e)}
                    name="active"
                    value="yes"
                  />
                }
                label={DispensingLanguage[lan][menukey]["Active"]}
                style={{float:'left', paddingLeft:'0px', marginRight:'7px'}}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={checkboxChecked(formData.temporaryPatient)}
                    onChange={(e) => handleCheck(e)}
                    name="temporaryPatient"
                    value="yes"
                    disabled={!!props.permissionType}
                  />
                }
                label={DispensingLanguage[lan][menukey]["Temporary Patient"]}
                style={{float:'left', paddingLeft:'0px', marginRight:'7px'}}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <div className="firstProtocolName">
                <h6>
                  {DispensingLanguage[lan][menukey]["First Protocol"]}
                  {": "}
                </h6>
                <p>{formData.firstProtocolName}</p>
              </div>
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                disabled={true}
                id="address"
                name="address"
                label={DispensingLanguage[lan][menukey]["Address"]}
                value={fieldStr(formData.address)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                disabled={true}
                id="contactNumber"
                name="contactNumber"
                label={DispensingLanguage[lan][menukey]["Contact#"]}
                value={fieldStr(formData.contactNumber)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                variant="standard"
                disabled={true}
                id="email"
                name="email"
                label={DispensingLanguage[lan][menukey]["E-mail"]}
                value={fieldStr(formData.email)}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChange(e)}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={lan === "en_GB" ? enGB : fr}
              >
                <DatePicker
                  disabled={!!props.permissionType}
                  label={DispensingLanguage[lan][menukey]["Registered"]}
                  disableFuture={true}
                  value={formData.registered || null}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => handleRDateChange(e, "registered")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      required
                      error={!!errorObject.registered}
                      helperText={errorObject.registered}
                      id="registered-date-picker-dialog"
                      name="registered"
                      fullWidth
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormControl variant="standard" className={classes.fullWidth}>
                <InputLabel id="language-preference-select-label">
                  {DispensingLanguage[lan][menukey]["MMD Status"]}
                </InputLabel>
                <Select
                  labelId="marital-status-select-label"
                  id="MmdId"
                  name="MmdId"
                  value={fieldStr(formData.MmdId)}
                  disabled={
                    formData.ExistingMmdId || props.permissionType
                      ? true
                      : false
                  }
                  onChange={handleChange}
                  label={DispensingLanguage[lan][menukey]["MMD Status"]}
                >
                  {MMDStatus.map((item, index) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormControl className={classes.fullWidth}>
                <Autocomplete
                  autoHighlight
                  id="ProtocolId"
                  disabled={
                    formData.ExistingProtocolId || props.permissionType
                      ? true
                      : false
                  }
                  options={CurrentRegimen}
                  onChange={(event, valueobj) =>
                    handleChangeChoosen(
                      "ProtocolId",
                      valueobj,
                      valueobj ? valueobj.id : "",
                    )
                  }
                  getOptionLabel={(option) => option?.name ?? ""}
                  isOptionEqualToValue={(option, value) =>
                    value?.id == null || option?.id === value?.id
                  }
                  value={chosenValues["ProtocolId"]}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id ?? option.name}>
                      <Typography className="sw_fontSize">
                        {option.name}
                      </Typography>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        DispensingLanguage[lan][menukey]["Current Regimen"]
                      }
                      variant="standard"
                      error={!!errorObject.ProtocolId}
                      helperText={errorObject.ProtocolId}
                      id="ProtocolId"
                      name="ProtocolId"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={DispensingLanguage[lan][menukey]["deceased"]}
                      disabled={!!props.permissionType}
                      value={formData.deceased || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "deceased")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          id="deceased-date-picker-dialog"
                          name="deceased"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <FormControl
                    className="sw_radiogroup"
                    component="fieldset"
                    disabled={!!props.permissionType}
                  >
                    <RadioGroup
                      row
                      aria-label="OriginTypeId"
                      name="OriginTypeId"
                      value={fieldStr(formData.OriginTypeId)}
                      onChange={handleChange}
                    >
                      {OriginType.map((item, index) => {
                        return (
                          <FormControlLabel
                            key={item.id}
                            value={item.id}
                            control={<Radio />}
                            label={DispensingLanguage[lan][menukey][item.name]}
                          ></FormControlLabel>
                        );
                      })}
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={DispensingLanguage[lan][menukey]["Transffered In"]}
                      disabled={!!props.permissionType}
                      value={formData.transfferedIn || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "transfferedIn")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          id="transfferedIn-date-picker-dialog"
                          name="transfferedIn"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                {formData.OriginTypeId === 1 ? (
                  <Grid item xs={12} sm={4}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        //disableClearable
                        disabled={
                          formData.transfferedIn && props.permissionType == 0
                            ? false
                            : true
                        }
                        id="TransferFromFacilityId"
                        options={FacilityList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosen(
                            "TransferFromFacilityId",
                            valueobj,
                            valueobj ? valueobj.id : "",
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={chosenValues["TransferFromFacilityId"]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Transfer From"]
                            }
                            variant="standard"
                            error={!!errorObject.TransferFromFacilityId}
                            helperText={errorObject.TransferFromFacilityId}
                            id="TransferFromFacilityId"
                            name="TransferFromFacilityId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={4}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        //disableClearable
                        disabled={
                          formData.transfferedIn && props.permissionType == 0
                            ? false
                            : true
                        }
                        id="TransferFromCountryId"
                        options={CountryAll}
                        onChange={(event, valueobj) =>
                          handleChangeChoosen(
                            "TransferFromCountryId",
                            valueobj,
                            valueobj ? valueobj.id : "",
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={chosenValues["TransferFromCountryId"]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Transfer From"]
                            }
                            variant="standard"
                            error={!!errorObject.TransferFromCountryId}
                            helperText={errorObject.TransferFromCountryId}
                            id="TransferFromCountryId"
                            name="TransferFromCountryId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={
                        DispensingLanguage[lan][menukey]["Transferred Out"]
                      }
                      disabled={!!props.permissionType}
                      value={formData.transferredOut || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "transferredOut")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          id="transferredOut-date-picker-dialog"
                          name="transferredOut"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                {formData.OriginTypeId === 1 ? (
                  <Grid item xs={12} sm={6}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        //disableClearable
                        disabled={
                          formData.transferredOut && props.permissionType == 0
                            ? false
                            : true
                        }
                        id="TransferToFacilityId"
                        options={FacilityList}
                        onChange={(event, valueobj) =>
                          handleChangeChoosen(
                            "TransferToFacilityId",
                            valueobj,
                            valueobj ? valueobj.id : "",
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={chosenValues["TransferToFacilityId"]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Transfer To"]
                            }
                            variant="standard"
                            error={!!errorObject.TransferToFacilityId}
                            helperText={errorObject.TransferToFacilityId}
                            id="TransferToFacilityId"
                            name="TransferToFacilityId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={6}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        //disableClearable
                        disabled={
                          formData.transferredOut && props.permissionType == 0
                            ? false
                            : true
                        }
                        id="TransferToCountryId"
                        options={CountryAll}
                        onChange={(event, valueobj) =>
                          handleChangeChoosen(
                            "TransferToCountryId",
                            valueobj,
                            valueobj ? valueobj.id : "",
                          )
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={chosenValues["TransferToCountryId"]}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Transfer To"]
                            }
                            variant="standard"
                            error={!!errorObject.TransferToCountryId}
                            helperText={errorObject.TransferToCountryId}
                            id="TransferToCountryId"
                            name="TransferToCountryId"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={DispensingLanguage[lan][menukey]["Defaulter"]}
                      disabled={!!props.permissionType}
                      value={formData.defaulter || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "defaulter")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          id="defaulter-date-picker-dialog"
                          name="defaulter"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={DispensingLanguage[lan][menukey]["Stopped"]}
                      disabled={!!props.permissionType}
                      value={formData.stopped || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "stopped")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          error={!!errorObject.stopped}
                          helperText={errorObject.stopped}
                          id="stopped"
                          name="stopped"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="language-preference-select-label">
                      {DispensingLanguage[lan][menukey]["MMD Status"]}
                    </InputLabel>
                    <Select
                      labelId="marital-status-select-label"
                      id="MmdId"
                      name="MmdId"
                      value={formData.MmdId}
                      disabled={formData.ExistingMmdId?true:false}
                      onChange={handleChange}
                    label={DispensingLanguage[lan][menukey]["MMD Status"]}>
                      {MMDStatus.map((item, index) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                      })}
                    </Select>
                </FormControl>
              </Grid> */}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2} className="checkBoxCustom">
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={checkboxChecked(formData.PreEP)}
                        onChange={(e) => handleCheckPreEP(e)}
                        name="PreEP"
                        //value="yes"
                        value="no"
                        disabled={!!props.permissionType}
                      />
                    }
                    label={DispensingLanguage[lan][menukey]["PreEP"]}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-label">
                      {DispensingLanguage[lan][menukey]["Patient Co-infection"]}
                    </InputLabel>
                    <Select
                      labelId="marital-status-select-label"
                      id="PatientcoinfectionId"
                      name="PatientcoinfectionId"
                      value={fieldStr(formData.PatientcoinfectionId)}
                      onChange={handleChange}
                      disabled={!!props.permissionType}
                      label={
                        DispensingLanguage[lan][menukey]["Patient Co-infection"]
                      }
                    >
                      <MenuItem value="">
                        {
                          DispensingLanguage[lan][menukey][
                            "Select Patient Co-infection"
                          ]
                        }
                      </MenuItem>
                      {PatientCoInfection_List.map((item, index) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <FormControl variant="standard" className={classes.fullWidth}>
                    <InputLabel id="demo-simple-select-label">
                      {DispensingLanguage[lan][menukey]["Key Population Type"]}
                    </InputLabel>
                    <Select
                      disabled={!!props.permissionType}
                      labelId="marital-status-select-label"
                      id="KeypopulationTypeId"
                      name="KeypopulationTypeId"
                      value={fieldStr(formData.KeypopulationTypeId)}
                      onChange={handleChange}
                      label={
                        DispensingLanguage[lan][menukey]["Key Population Type"]
                      }
                    >
                      <MenuItem value="">
                        {
                          DispensingLanguage[lan][menukey][
                            "Select Key Population Type"
                          ]
                        }
                      </MenuItem>
                      {KeyPopulationType_List.map((item, index) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={7}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} className="sw_active_patient">
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={checkboxChecked(formData.InhIsPrevious)}
                        onChange={(e) => handleCheck(e)}
                        name="InhIsPrevious"
                        //value="yes"
                        value="no"
                        disabled={!!props.permissionType}
                      />
                    }
                    label={
                      DispensingLanguage[lan][menukey][
                        "previously received INH"
                      ]
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      label={DispensingLanguage[lan][menukey]["INH Start Date"]}
                      disabled={!!props.permissionType}
                      value={formData.InhStartDate || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "InhStartDate")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          error={!!errorObject.InhStartDate}
                          helperText={errorObject.InhStartDate}
                          id="InhStartDate"
                          name="InhStartDate"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={lan === "en_GB" ? enGB : fr}
                  >
                    <DatePicker
                      disabled={!!props.permissionType}
                      label={DispensingLanguage[lan][menukey]["INH End Date"]}
                      value={formData.InhEndDate || null}
                      inputFormat="dd/MM/yyyy"
                      onChange={(e) => handleRDateChange(e, "InhEndDate")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          error={!!errorObject.InhEndDate}
                          helperText={errorObject.InhEndDate}
                          id="InhEndDate"
                          name="InhEndDate"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                {/* <Grid item xs={12} sm={3}>
                        <FormControl variant="standard" className={classes.fullWidth}>
                          <InputLabel id="demo-simple-select-label">
                          {DispensingLanguage[lan][menukey]["Cohort"]}
                          </InputLabel>
                          <Select
                          labelId="marital-status-select-label"
                          id="CohortId"
                          name="CohortId"
                          value={formData.CohortId}
                          onChange={handleChange}
                          label={DispensingLanguage[lan][menukey]["Cohort"]}>
                            <MenuItem value="">{DispensingLanguage[lan][menukey]["Select Cohort"]}</MenuItem>
                          {CohortTypeList.map((item, index) => {
                            return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                          })}
                          </Select>
                        </FormControl>
                    </Grid> */}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3} className="checkBoxCustom">
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={checkboxChecked(formData.isArmy)}
                        onChange={(e) => handleCheckisArmy(e)}
                        name="isArmy"
                        value="no"
                        disabled={!!props.permissionType}
                      />
                    }
                    label={DispensingLanguage[lan][menukey]["Army Patient"]}
                  />
                </Grid>

                <Grid item xs={12} sm={5}>
                  <FormControl className={classes.fullWidth}>
                    <Autocomplete
                      autoHighlight
                      id="CohortId"
                      disabled={!!props.permissionType}
                      options={CohortTypeList}
                      onChange={(event, valueobj) =>
                        handleChangeChoosen(
                          "CohortId",
                          valueobj,
                          valueobj ? valueobj.id : "",
                        )
                      }
                      getOptionLabel={(option) => option?.name ?? ""}
                      isOptionEqualToValue={(option, value) =>
                        value?.id == null || option?.id === value?.id
                      }
                      value={chosenValues["CohortId"]}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id ?? option.name}>
                          <Typography className="sw_fontSize">
                            {option.name}
                          </Typography>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={DispensingLanguage[lan][menukey]["Cohort"]}
                          variant="standard"
                          error={!!errorObject.CohortId}
                          helperText={errorObject.CohortId}
                          id="CohortId"
                          name="CohortId"
                          fullWidth
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            {/* end of from */}

            <Grid item xs={12} sm={12}>
              <div className={classes.root}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={tabValue}
                    onChange={tabChangeHandler}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    {/* <Tab label="Contact Details" {...a11yProps(0)} /> */}

                    <Tab
                      label={
                        DispensingLanguage[lan][menukey]["Anthropometrics"]
                      }
                      {...a11yProps(0)}
                    />
                    <Tab
                      label={DispensingLanguage[lan][menukey]["Prescriptions"]}
                      {...a11yProps(1)}
                    />
                    <Tab
                      label={DispensingLanguage[lan][menukey]["Lab Results"]}
                      {...a11yProps(2)}
                    />
                    <Tab
                      label={
                        DispensingLanguage[lan][menukey]["Weight CD4 Count"]
                      }
                      {...a11yProps(3)}
                    />
                    <Tab
                      label={DispensingLanguage[lan][menukey]["Viral Load"]}
                      {...a11yProps(4)}
                    />
                    <Tab
                      label={DispensingLanguage[lan][menukey]["Allergies"]}
                      {...a11yProps(5)}
                    />
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={tabValue}
                  onChangeIndex={handleChangeIndex}
                >
                  <TabPanel value={tabValue} index={0}>
                    <Grid container spacing={5}>
                      <Grid item xs={11}></Grid>
                      <Grid item xs={1}>
                        <Button
                          disabled={!!props.permissionType}
                          variant="outlined"
                          onClick={() => handleClickOpen("anthropometricsData")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                          </svg>
                        </Button>
                        <AnthropometricsTab
                          open={openAnthropometricDialog}
                          setOpen={setOpen}
                          handleClickOpen={handleClickOpen}
                          handleClose={handleClose}
                          anthropometricData={anthropometricData || {}}
                          handleChangeByTabs={handleChangeByTabs}
                          handleSubmitByTabs={handleSubmitByTabs}
                          handleRDateChangeByTabs={handleRDateChangeByTabs}
                          errorAnthropometricsData={errorAnthropometricsData}
                        />
                      </Grid>
                    </Grid>
                    <br />
            
                    <ReactTabulator
                      columns={anthropometricDataColumns}
                      data={formData.anthropometricsData || []}
                      initialSort={[{ column: "date", dir: "desc" }]}
                    />
                 
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    {/* prescriptionDataColumns */}
                    {addPatientForm == false &&
                      patientsPrescriptions &&
                      patientsPrescriptions.length > 0 && (
                        <ReactTabulator
                          columns={prescriptionDataColumns}
                          data={patientsPrescriptions}
                          initialSort={[
                            { column: "AppointmentDate", dir: "desc" },
                          ]}
                          events={{
                            rowDblClick: (e, row) =>
                              tableRowDoubleClick(e, row),
                          }}
                        />
                      )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                    <Grid container spacing={5}>
                      <Grid item xs={11}></Grid>
                      <Grid item xs={1}>
                        {/* <Button
                        variant="outlined"
                        onClick={() => handleClickOpen("labResultsData")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                        </svg>
                      </Button> */}
                        <LabResultsTab
                          open={openLabResultDialog}
                          setOpen={setOpen}
                          handleClickOpen={handleClickOpen}
                          handleClose={handleClose}
                          labResultData={labResultData || {}}
                          handleChangeByTabs={handleChangeByTabs}
                          handleSubmitByTabs={handleSubmitByTabs}
                          handleRDateChangeByTabs={handleRDateChangeByTabs}
                          errorLabResultsData={errorLabResultsData}
                        />
                      </Grid>
                    </Grid>
                    {/*  <br /> */}
                    {formData.labResultsData && (
                      <ReactTabulator
                        columns={labResultsDataColumns}
                        data={formData.labResultsData || []}
                        height={350}
                        initialSort={[{ column: "testDate", dir: "desc" }]}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={3}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={calculateWeightCD4Count()}
                    />
                  </TabPanel>
                  <TabPanel value={tabValue} index={4}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={calculateViralLoad()}
                    />
                  </TabPanel>

                  <TabPanel value={tabValue} index={5}>
                    <Grid container spacing={5}>
                      <Grid item xs={11}></Grid>
                      <Grid item xs={1}>
                        <Button
                          disabled={!!props.permissionType}
                          variant="outlined"
                          onClick={() => handleClickOpen("allergiesData")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                          </svg>
                        </Button>
                        <AllergiesTab
                          open={openAllergyDialog}
                          setOpen={setOpen}
                          handleClickOpen={handleClickOpen}
                          handleClose={handleClose}
                          allergyData={allergyData || {}}
                          handleChangeByTabs={handleChangeByTabs}
                          handleSubmitByTabs={handleSubmitByTabs}
                          handleRDateChangeByTabs={handleRDateChangeByTabs}
                          errorAllergiesData={errorAllergiesData}
                        />
                      </Grid>
                    </Grid>
                    <br />
                    <ReactTabulator
                      columns={allergyDataColumns}
                      data={formData.allergiesData || []}
                      initialSort={[{ column: "date", dir: "desc" }]}
                    />
                  </TabPanel>
                </SwipeableViews>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default PatientFormData;

const useStyles = makeStyles({
  patientPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
